import dayjs from 'dayjs'

import COUNTRIES from './countries'
import PROVIDERS from './providers'
import getTodayStartDate from '../utils/getTodayStartDate'
import TOLGEE_GLOBALS from '../utils/tolgeeGlobals'

const TODAY = dayjs()
export const START_OF_THE_DAY = dayjs(getTodayStartDate())
const END_OF_THE_DAY = dayjs().endOf('day').valueOf()
export const BEGINNING_OF_TIME = dayjs('01-01-2005').valueOf()
const LAST_24_HOURS = dayjs().subtract(24, 'hour').valueOf()
export const LAST_7_DAYS = dayjs(START_OF_THE_DAY.subtract(7, 'day')).valueOf()
export const LAST_30_DAYS = dayjs(START_OF_THE_DAY.subtract(30, 'day')).valueOf()
export const LAST_3_MONTHS = dayjs(START_OF_THE_DAY.subtract(3, 'month')).valueOf()
export const LAST_6_MONTHS = dayjs(START_OF_THE_DAY.subtract(6, 'month')).valueOf()
const LAST_9_MONTHS = dayjs(START_OF_THE_DAY.subtract(9, 'month')).valueOf()
export const LAST_12_MONTHS = dayjs(START_OF_THE_DAY.subtract(12, 'month')).valueOf()
export const LAST_24_MONTHS = dayjs(START_OF_THE_DAY.subtract(24, 'month')).valueOf()
export const LAST_36_MONTHS = dayjs(START_OF_THE_DAY.subtract(36, 'month')).valueOf()

const checkboxProvidersOptions = PROVIDERS.NAMES.map(v => ({
  value: v.KEY,
  text: PROVIDERS[v.KEY].NAME,
  label: PROVIDERS[v.KEY].NAME,
  color: PROVIDERS[v.KEY].COLOR,
}))

const providers = PROVIDERS.NAMES.map(v => ({
  value: v.KEY,
  text: PROVIDERS[v.KEY].NAME,
  label: PROVIDERS[v.KEY].NAME,
  color: PROVIDERS[v.KEY].COLOR,
}))

const generalProviderType = {
  label: TOLGEE_GLOBALS.generalProviderTitle,
  value: 'all',
}

const providersWithGeneral = [generalProviderType, ...providers]

const searchCreatorsSortBy = [
  {
    key: 'subscribers',
    value: 'subscribers',
    label: 'Followers/Subscribers',
  },
  {
    key: 'views',
    value: 'views',
    label: 'Views',
  },
]

const searchCreatorsTopicSortBy = [
  {
    key: 'topic_sum_likes',
    value: 'topic_sum_likes',
    label: 'Video likes',
    tooltipText: 'Sorting based on the number of video likes within a topic.',
  },
  {
    key: 'subscribers',
    value: 'subscribers',
    label: 'Followers/Subscribers',
  },
  {
    key: 'views',
    value: 'views',
    label: 'Views',
  },
  {
    key: 'trending_score',
    value: 'trending_score',
    label: 'Trending',
    tooltipText: 'Creators with the fastest growing subscriber base for each tier and provider over the last month',
  },
]

const videosSortBy = [
  {
    key: 'likes',
    value: 'likes',
    label: 'Likes',
    tolgee: TOLGEE_GLOBALS.likes,
  },
  {
    key: 'views',
    value: 'views',
    label: 'Views',
    tolgee: TOLGEE_GLOBALS.views,
  },
  {
    key: 'comments',
    value: 'comments',
    label: 'Comments',
    tolgee: TOLGEE_GLOBALS.comments,
  },
  {
    key: 'published_at',
    value: 'published_at',
    label: 'Upload date',
    tolgee: TOLGEE_GLOBALS.uploadDate,
  },
]

const videosSortByCreatorTwitch = [
  {
    key: 'views',
    value: 'views',
    label: 'Views',
  },
  {
    key: 'published_at',
    value: 'published_at',
    label: 'Upload date',
  },
]

const tagListSortBy = [
  {
    key: 'avg',
    value: 'avg',
    label: 'Average',
  },
  {
    key: 'sum',
    value: 'sum',
    label: 'Total',
  },
]

const tagListDateRange = [
  {
    key: '12',
    value: 12,
    label: 'Last 12 months',
  },
  {
    key: '6',
    value: 6,
    label: 'Last 6 months',
  },
  {
    key: '3',
    value: 3,
    label: 'Last 3 months',
  },
  {
    key: '1',
    value: 1,
    label: 'Last 30 days',
  },
]

const compareTabs = [
  {
    key: 'topics',
    value: 'topics',
    label: 'Topics',
  },
  {
    key: 'creators',
    value: 'creators',
    label: 'Creators',
  },
]

const genders = [
  {
    key: 'all',
    value: '',
    label: 'All',
    filterName: 'Genders',
    tolgee: TOLGEE_GLOBALS['all'],
  },
  {
    key: 'f',
    value: 'f',
    label: 'Female',
    filterName: 'Genders',
    icon: 'female',
    tolgee: TOLGEE_GLOBALS['female'],
  },
  {
    key: 'm',
    value: 'm',
    label: 'Male',
    filterName: 'Genders',
    icon: 'male',
    tolgee: TOLGEE_GLOBALS['male'],
  },
]

const ages = [
  {
    key: 'all',
    value: '',
    label: 'All Ages',
    filterName: 'Ages',
    buttonLabel: 'All',
    tolgee: TOLGEE_GLOBALS['all'],
  },
  {
    key: 'a13_17',
    value: 'a13_17',
    label: '13 - 17',
    filterName: 'Ages',
    buttonLabel: 'Teens',
    tolgee: TOLGEE_GLOBALS['teens'],
  },
  {
    key: 'a18_24',
    value: 'a18_24',
    label: '18 - 24',
    filterName: 'Ages',
    buttonLabel: 'Young',
    tolgee: TOLGEE_GLOBALS['young'],
  },
  {
    key: 'a25_34',
    value: 'a25_34',
    label: '25 - 34',
    filterName: 'Ages',
    buttonLabel: 'Adults',
    tolgee: TOLGEE_GLOBALS['adults'],
  },
  {
    key: 'a35_44',
    value: 'a35_44',
    label: '35 - 44',
    filterName: 'Ages',
    buttonLabel: 'Mature',
    tolgee: TOLGEE_GLOBALS['mature'],
  },
  {
    key: 'a45_54',
    value: 'a45_54',
    label: '45 - 54',
    filterName: 'Ages',
    buttonLabel: 'Midlife',
    tolgee: TOLGEE_GLOBALS['midlife'],
  },
  {
    key: 'a55_64',
    value: 'a55_64',
    label: '55 - 64',
    filterName: 'Ages',
    buttonLabel: 'Seniors',
    tolgee: TOLGEE_GLOBALS['seniors'],
  },
  {
    key: 'a65_99',
    value: 'a65_99',
    label: '65 +',
    filterName: 'Ages',
    buttonLabel: 'Elders',
    tolgee: TOLGEE_GLOBALS['elders'],
  },
]

const audienceCountries = [
  {
    key: 'all',
    value: '',
    label: 'Worldwide',
    filterName: 'Countries',
  },
].concat(...COUNTRIES.map(v => ({ key: v.ALPHA_2, value: v.ALPHA_2, label: v.NAME, filterName: 'Countries' })))

const dateRangeSearch = [
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
  },
]

const dateRangeButtons = [
  {
    filterName: 'Period',
    key: 'All Time',
    label: 'All time',
    value: '',
  },
  {
    filterName: 'Period',
    key: 'last 30 days',
    label: 'Last 30 days',
    value: 1,
  },
  {
    filterName: 'Period',
    key: 'last 3 months',
    label: 'Last 3 months',
    value: 3,
  },
  {
    filterName: 'Period',
    key: 'last 6 months',
    label: 'Last 6 months',
    value: 6,
  },
  {
    filterName: 'Period',
    key: 'last 12 months',
    label: 'Last 12 months',
    value: 12,
  },
]

const uploadDateSearchVideos = [
  {
    label: 'All time',
    value: 'all',
    key: '-',
    filterName: 'Period',
  },
  {
    label: 'Last 7 days',
    value: '7d',
    key: '0',
    filterName: 'Period',
    rangeQuery: { gte: LAST_7_DAYS },
  },
  {
    label: 'Last 30 days',
    value: 1,
    key: '1',
    filterName: 'Period',
    rangeQuery: { gte: LAST_30_DAYS },
  },
  {
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
    rangeQuery: { gte: LAST_3_MONTHS },
  },
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
    rangeQuery: { gte: LAST_6_MONTHS },
  },
  {
    label: 'Last 9 months',
    value: 9,
    key: '9',
    filterName: 'Period',
    rangeQuery: { gte: LAST_9_MONTHS },
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
    rangeQuery: { gte: LAST_12_MONTHS },
  },
]

export const ALL_TIME_RANGE_QUERY = {
  gte: BEGINNING_OF_TIME,
  lte: END_OF_THE_DAY,
}

export const UPLOAD_DATE_RANGE_MAP = {
  all: ALL_TIME_RANGE_QUERY,
  today: { gte: START_OF_THE_DAY.valueOf() },
  0: { gte: LAST_7_DAYS },
  1: { gte: LAST_30_DAYS },
  3: { gte: LAST_3_MONTHS },
  6: { gte: LAST_6_MONTHS },
  12: { gte: LAST_12_MONTHS },
  24: { gte: LAST_24_MONTHS },
  36: { gte: LAST_36_MONTHS },
  '24h': { gte: LAST_24_HOURS },
}

const uploadDateSearchTopics = [
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
  },
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
  },
  {
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
  },
]

const customUploadDateRangeSearchVideos = [
  {
    label: 'All time',
    value: 'all',
    key: '-',
    filterName: 'Period',
  },
  {
    label: 'Last 24 hours',
    value: '24h',
    key: '24h',
    filterName: 'Period',
    start: dayjs().subtract(1, 'day'),
    end: TODAY,
    rangeQuery: { gte: dayjs().subtract(24, 'hour').valueOf() },
  },
  {
    label: 'Last 7 days',
    value: '7d',
    key: '0',
    filterName: 'Period',
    start: dayjs().subtract(1, 'week'),
    end: TODAY,
    rangeQuery: { gte: LAST_7_DAYS },
  },
  {
    label: 'Last 30 days',
    value: 1,
    key: '1',
    filterName: 'Period',
    start: dayjs().subtract(1, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_30_DAYS },
  },
  {
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
    start: dayjs().subtract(3, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_3_MONTHS },
  },
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
    start: dayjs().subtract(6, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_6_MONTHS },
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
    start: dayjs().subtract(12, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_12_MONTHS },
  },
  {
    //IMPORTANT! always leave the custom option as the last of the array
    label: 'Custom',
    value: function (gteValue, lteValue) {
      return `custom_${gteValue}_${lteValue}`
    },
    staticValue: window.location.search,
    key: 'custom',
    filterName: 'Period',
    rangeQuery: function (gteValue, lteValue) {
      return { gte: +gteValue, lte: +lteValue }
    },
  },
]

const dataRangeChart = [
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
  },
]

const dataRangeCompare = [
  {
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['3MonthsValue'],
  },
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['6MonthsValue'],
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['12MonthsValue'],
  },
  {
    label: 'Last 2 years',
    value: 24,
    key: '24',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['24MonthsValue'],
  },
  {
    label: 'Last 3 years',
    value: 36,
    key: '36',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['36MonthsValue'],
  },
]

const youtubeAuditDataRangeCompare = [
  {
    label: 'Last 30 days',
    value: 30,
    key: 'last 30 days',
    filterName: 'Period',
    tolgee: TOLGEE_GLOBALS['lastThirtyDays'],
  },
]

const language = [
  {
    key: 'eng',
    value: 'eng',
    label: 'English',
    filterName: 'Language',
  },
  {
    key: 'por',
    value: 'por',
    label: 'Portuguese',
    filterName: 'Language',
  },
  {
    key: 'spa',
    value: 'spa',
    label: 'Spanish',
    filterName: 'Language',
  },
  {
    key: 'all',
    value: '',
    label: 'All',
    filterName: 'Language',
  },
]

const countries = [
  {
    key: 'all',
    value: '',
    label: 'Worldwide',
    filterName: 'Countries',
  },
].concat(...COUNTRIES.map(v => ({ key: v.ALPHA_2, value: v.ALPHA_2, label: v.NAME, filterName: 'Countries' })))

const sortByAvgViewsEngagement = [
  {
    label: 'Engagement',
    key: 'engagement',
    value: 'engagement',
    tooltipText:
      'Our proprietary product metric calculated using social platforms metrics such as comments, reactions and likes.',
  },
  {
    label: 'Views',
    key: 'views',
    value: 'views',
  },
]

const creatorPerformanceSortBy = [
  {
    label: 'Subscribers',
    key: 'subscribers',
    value: 'subscribers',
    tolgee: TOLGEE_GLOBALS.subscribers,
  },
  {
    label: 'Views',
    key: 'views',
    value: 'views',
    tolgee: TOLGEE_GLOBALS.views,
  },
  {
    label: 'Likes',
    key: 'likes',
    value: 'likes',
    tolgee: TOLGEE_GLOBALS.likes,
  },
  {
    label: 'Video Count',
    key: 'videos',
    value: 'videos',
    tolgee: TOLGEE_GLOBALS.videos,
  },
]

const compareTopicsRelevanceLogic = [
  {
    label: 'Weekly',
    key: 'weekly',
    value: 'week',
    tolgee: TOLGEE_GLOBALS.weekly,
  },
  {
    label: 'Monthly',
    key: 'monthly',
    value: 'month',
    tolgee: TOLGEE_GLOBALS.monthly,
  },
]

const topicPerformanceSortBy = [
  {
    label: 'Views',
    key: 'views',
    value: 'views',
  },
  {
    label: 'Likes',
    key: 'likes',
    value: 'likes',
  },
]

const cultureTopicsSortBy = [
  {
    label: 'Relevance',
    key: 'topicViewership',
    value: 'topicViewership',
    tooltipText: 'The Relevance indicates how relevant a topic is in terms of engagement during a given period.',
  },
  {
    label: 'Viewership',
    key: 'evp',
    value: 'index',
    tooltipText:
      'Estimated Viewership Index indicates the size of topics, ranging from 1 to 10, by the audience who consume this content in the last 12 months.',
  },
  {
    label: 'Engag./Video',
    key: 'engagement',
    value: 'avgEngagement',
    tooltipText:
      'Calculated using social platforms metrics such as comments, reactions and likes of a sample of videos published in one year.',
  },
  {
    label: 'Views/Video',
    key: 'views',
    value: 'avgViews',
    tooltipText: 'Calculated using a video sample published in one year.',
  },
]

const cultureSubtopicsSortBy = [
  {
    label: 'Engag./Video',
    key: 'engagement',
    value: 'avgEngagement',
    tooltipText:
      'Calculated using social platforms metrics such as comments, reactions and likes of a sample of videos published in one year.',
  },
  {
    label: 'Views/Video',
    key: 'views',
    value: 'avgViews',
    tooltipText: 'Calculated using a video sample published in one year.',
  },
]

const viewsEngagement = [
  {
    label: 'Engag./Video',
    key: 'engagement',
    value: 'engagement',
    tooltipText: 'Engagement is calculated using social platforms metrics such as comments, reactions and likes.',
  },
  {
    label: 'Views/Video',
    key: 'views',
    value: 'views',
  },
]

const chartLogic = [
  {
    key: 'chartLogic',
    value: 'cumulative',
    label: 'Cumulative',
    filterName: 'chartLogic',
  },
  {
    key: 'chartLogic',
    value: 'monthly',
    label: 'Monthly',
    filterName: 'chartLogic',
  },
  {
    key: 'chartLogic',
    value: 'daily',
    label: 'Daily',
    filterName: 'chartLogic',
  },
]

const chart = {
  viewsEngagement,
  creatorPerformanceSortBy,
  compareTopicsRelevanceLogic,
  topicPerformanceSortBy,
  cultureTopicsSortBy,
  cultureSubtopicsSortBy,
  providers: checkboxProvidersOptions,
  chartLogic,
  dateRange: dataRangeChart,
}

const comparePage = {
  comparing: compareTabs,
  dateRange: dataRangeCompare,
  creators: {},
  subtopics: {},
  topics: {},
  savedPostSearches: {},
  niches: {},
  tags: {},
  industry_topic: {},
  global_topic: {},
  theme: {},
  segment: {},
  subject: {},
  entity_query: {},
  entity: {},
}

const youtubeAuditComparePage = {
  comparing: compareTabs,
  dateRange: youtubeAuditDataRangeCompare,
  creators: {},
  subtopics: {},
  topics: {},
  savedPostSearches: {},
  niches: {},
  tags: {},
  industry_topic: {},
  global_topic: {},
  theme: {},
  segment: {},
  subject: {},
  entity_query: {},
  entity: {},
}

const minutesToSeconds = minutes => Number.parseFloat(minutes * 60)

const length = [
  {
    key: 'len0',
    rangeQuery: { lte: 15 },
    value: 0,
    label: '0s',
    filterName: 'Duration',
  },
  {
    key: 'len15s',
    value: 15,
    rangeQuery: { lte: 15 },
    label: '15s',
    filterName: 'Duration',
  },
  {
    key: 'len1',
    value: 60,
    rangeQuery: { lte: 60 },
    label: '1min',
    filterName: 'Duration',
  },
  {
    key: 'len3',
    value: minutesToSeconds(3),
    rangeQuery: { lte: minutesToSeconds(3) },
    label: '3min',
    filterName: 'Duration',
  },
  {
    key: 'len4',
    value: minutesToSeconds(4),
    rangeQuery: { lte: minutesToSeconds(4) },
    label: '4min',
    filterName: 'Duration',
  },
  {
    key: 'len10',
    value: minutesToSeconds(10),
    rangeQuery: { gte: minutesToSeconds(4), lte: minutesToSeconds(10) },
    label: '10min',
    filterName: 'Duration',
  },
  {
    key: 'len20',
    value: minutesToSeconds(20),
    rangeQuery: { gte: minutesToSeconds(10), lte: minutesToSeconds(20) },
    label: '20min',
    filterName: 'Duration',
  },
  {
    key: 'len20+',
    value: 0,
    rangeQuery: { gte: minutesToSeconds(20) },
    label: '+20min',
    filterName: 'Duration',
  },
]

const durationOptions = {
  minDuration: length,
  maxDuration: length,
}

const likes = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    filterName: 'Likes',
  },
  {
    key: 'lik0_50',
    value: 'lik0_50',
    rangeQuery: { lte: 50000 },
    label: '0 - 50k',
    filterName: 'Likes',
  },
  {
    key: 'lik50_100',
    value: 'lik50_100',
    rangeQuery: { gte: 50000, lte: 100000 },
    label: '50k - 100k',
    filterName: 'Likes',
  },
  {
    key: 'lik100_500',
    value: 'lik100_500',
    rangeQuery: { gte: 100000, lte: 500000 },
    label: '100k - 500k',
    filterName: 'Likes',
  },
  {
    key: 'lik500_1m',
    value: 'lik500_1m',
    rangeQuery: { gte: 500000, lte: 1000000 },
    label: '500k - 1m',
    filterName: 'Likes',
  },
  {
    key: 'lik1m+',
    value: 'lik1m+',
    rangeQuery: { gte: 1000000 },
    label: '1m +',
    filterName: 'Likes',
  },
]

const comments = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    filterName: 'Comments',
  },
  {
    key: 'com0_500',
    value: 'com0_500',
    rangeQuery: { lte: 500 },
    label: '0 - 500',
    filterName: 'Comments',
  },
  {
    key: 'com500_1000',
    value: 'com500_1000',
    rangeQuery: { gte: 500, lte: 1000 },
    label: '500 - 1k',
    filterName: 'Comments',
  },
  {
    key: 'com1k_10k',
    value: 'com1k_10k',
    rangeQuery: { gte: 1000, lte: 10000 },
    label: '1k - 10k',
    filterName: 'Comments',
  },
  {
    key: 'com10k_100k',
    value: 'com10k_100k',
    rangeQuery: { gte: 10000, lte: 100000 },
    label: '10k - 100k',
    filterName: 'Comments',
  },
  {
    key: 'com100k+',
    value: 'com100k+',
    rangeQuery: { gte: 100000 },
    label: '100k +',
    filterName: 'Comments',
  },
]

const engagement = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    filterName: 'Engagement',
  },
  {
    key: 'eng0_100k',
    value: 'eng0_100k',
    rangeQuery: { lte: 100000 },
    label: '0 - 100k',
    filterName: 'Engagement',
  },
  {
    key: 'eng100_500k',
    value: 'eng100_500k',
    rangeQuery: { gte: 100000, lte: 500000 },
    label: '100k - 500k',
    filterName: 'Engagement',
  },
  {
    key: 'eng500_1m',
    value: 'eng500_1m',
    rangeQuery: { gte: 500000, lte: 1000000 },
    label: '500k - 1m',
    filterName: 'Engagement',
  },
  {
    key: 'eng1m_10m',
    value: 'eng1m_10m',
    rangeQuery: { gte: 1000000, lte: 10000000 },
    label: '1m - 10m',
    filterName: 'Engagement',
  },
  {
    key: 'eng10m+',
    value: 'eng10m+',
    rangeQuery: { gte: 10000000 },
    label: '10m +',
    filterName: 'Engagement',
  },
]

const views = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    filterName: 'Views',
  },
  {
    key: 'views1k+',
    value: 'views1k+',
    rangeQuery: { gte: 1000 },
    label: '1K+',
    filterName: 'Views',
  },
  {
    key: 'views10k+',
    value: 'views10k+',
    rangeQuery: { gte: 10000 },
    label: '10K+',
    filterName: 'Views',
  },
  {
    key: 'views100k+',
    value: 'views100k+',
    rangeQuery: { gte: 100000 },
    label: '100K+',
    filterName: 'Views',
  },
  {
    key: 'views1m+',
    value: 'views1m+',
    rangeQuery: { gte: 1000000 },
    label: '1M+',
    filterName: 'Views',
  },
]

const numberOfVideos = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    filterName: 'Videos',
  },
  {
    key: 'videos0_50',
    value: 'videos0_50',
    rangeQuery: { lte: 50 },
    label: '0 - 50',
    filterName: 'Videos',
  },
  {
    key: 'videos50_500',
    value: 'videos50_200',
    rangeQuery: { gte: 50, lte: 200 },
    label: '50 - 200',
    filterName: 'Videos',
  },
  {
    key: 'videos200_500',
    value: 'videos200_500',
    rangeQuery: { gte: 200, lte: 500 },
    label: '200 - 500',
    filterName: 'Videos',
  },
  {
    key: 'videos500_1000',
    value: 'videos500_1000',
    rangeQuery: { gte: 500, lte: 1000 },
    label: '500 - 1000',
    filterName: 'Videos',
  },
  {
    key: 'videos1000+',
    value: 'videos1000+',
    rangeQuery: { gte: 1000 },
    label: '1000+',
    filterName: 'Videos',
  },
]

const subtopicType = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    subLabel: '',
    filterName: 'Subtopic Type',
  },
  {
    key: 'trending',
    value: 'trending',
    label: 'Trending',
    subLabel: '',
    filterName: 'Subtopic Type',
  },
]

const creatorTier = [
  {
    key: 'all',
    value: 'all',
    label: 'All Tiers',
    subLabel: '',
    filterName: 'Creator Tier',
  },
  {
    key: 'icons',
    value: 'icons',
    label: 'Icons',
    subLabel: '5M+ Followers/Subscribers',
    rangeQuery: { gte: 5000000 },
    filterName: 'Creator Tier',
  },
  {
    key: 'topCreators',
    value: 'topCreators',
    label: 'Top Creators',
    subLabel: '1 to 5M  Followers/Subscribers',
    rangeQuery: { gte: 1000000, lte: 5000000 },
    filterName: 'Creator Tier',
  },
  {
    key: 'midCreators',
    value: 'midCreators',
    label: 'Mid Creators',
    subLabel: '200k to 1M  Followers/Subscribers',
    rangeQuery: { gte: 200000, lte: 1000000 },
    filterName: 'Creator Tier',
  },
  {
    key: 'microCreators',
    value: 'microCreators',
    label: 'Micro Creators',
    subLabel: 'up to 200K  Followers/Subscribers',
    rangeQuery: { lte: 200000 },
    filterName: 'Creator Tier',
  },
]

const topicCategory = [
  {
    value: '',
    label: 'All Territories',
  },
]

const subtopicTopic = [
  {
    value: '',
    label: 'All Topics',
  },
]

const subtopicCategory = [
  {
    value: '',
    label: 'All Territories',
    topicIds: [],
  },
]

const categories = [
  {
    value: '',
    label: 'All Territories',
    topicIds: [],
  },
]

const subtopic = [
  {
    value: '',
    label: 'All',
  },
]

const topic = [
  {
    value: '',
    label: 'All',
  },
]

const musicGenre = [
  {
    value: '',
    label: 'All',
  },
]

const musicSubgenre = [
  {
    value: '',
    label: 'All',
  },
]

const formatId = [
  {
    value: '',
  },
]

const title = [
  {
    value: '',
    label: 'title',
  },
]

const titleAnd = [
  {
    value: '',
    label: 'titleAnd',
  },
]

const titleOr = [
  {
    value: '',
    label: 'titleOr',
  },
]

const titleNot = [
  {
    value: '',
    label: 'titleNot',
  },
]

const subtopicSearchTerm = [
  {
    value: '',
    label: 'subtopicSearchTerm',
  },
]

const searchTopicType = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    subLabel: '',
    filterName: 'Following',
  },
  {
    key: 'isFollowing',
    value: 'isFollowing',
    label: 'Following',
    subLabel: '',
    filterName: 'Following',
  },
]

const searchSubtopicType = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    subLabel: '',
    filterName: 'Search Subtopic Type',
  },
  {
    key: 'trending',
    value: 'trending',
    label: 'Trending',
    subLabel: '',
    filterName: 'Search Subtopic Type',
  },
]

const followedCreators = {
  key: 'isFollowing',
  value: false,
  label: 'Following',
  filterName: 'Following',
}

const trendingCreators = {
  key: 'isTrending',
  value: false,
  label: 'Trending',
  subLabel: '',
  filterName: 'Trending Creator',
}

const isLive = {
  key: 'isLive',
  value: false,
  label: 'Live',
  filterName: 'Live',
}

const isAdvertisement = {
  key: 'isPublicity',
  value: false,
  label: 'Advertisement',
  filterName: 'Advertisement',
}

const creatorType = [
  {
    key: 'all',
    value: 'all',
    label: 'All',
    subLabel: '',
    filterName: 'Creator type',
  },
  {
    key: 'creators',
    value: 'creators',
    label: 'Creators',
    subLabel: '',
    filterName: 'Creator type',
  },
  {
    key: 'brands',
    value: 'brands',
    label: 'Brands',
    subLabel: '',
    filterName: 'Creator type',
  },
]

const performanceDateRange = [
  {
    filterName: 'Period',
    key: '3 months',
    label: '3 months',
    value: 3,
  },
  {
    filterName: 'Period',
    key: '6 months',
    label: '6 months',
    value: 6,
  },
  {
    filterName: 'Period',
    key: '12 months',
    label: '12 months',
    value: 12,
  },
]

const tagTitle = [
  {
    value: '',
  },
]

const uploadTrendingDates = [
  {
    start: dayjs().subtract(1, 'week'),
    end: TODAY,
    label: 'Last 7 days',
    value: '7d',
    key: '1',
    filterName: 'Period',
    rangeQuery: { gte: LAST_7_DAYS },
  },
  {
    label: 'Today',
    value: 'today',
    key: 'today',
    start: dayjs().startOf('day'),
    end: TODAY,
    rangeQuery: { gte: START_OF_THE_DAY.valueOf() },
  },
  {
    start: dayjs().subtract(1, 'month'),
    end: TODAY,
    label: 'Last 30 days',
    value: 1,
    key: '2',
    filterName: 'Period',
    rangeQuery: { gte: LAST_30_DAYS },
  },
  {
    start: dayjs().subtract(3, 'month'),
    end: TODAY,
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
    rangeQuery: { gte: LAST_3_MONTHS },
  },
  {
    start: dayjs().subtract(6, 'month'),
    end: TODAY,
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
    rangeQuery: { gte: LAST_6_MONTHS },
  },
  {
    start: dayjs().subtract(12, 'month'),
    end: TODAY,
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
    rangeQuery: { gte: LAST_12_MONTHS },
  },
  {
    //IMPORTANT! always leave the custom option as the last of the array
    label: 'Custom',
    value: function (gteValue, lteValue) {
      return `custom_${gteValue}_${lteValue}`
    },
    staticValue: window.location.search,
    key: 'custom',
    filterName: 'Period',
    rangeQuery: function (gteValue, lteValue) {
      return { gte: +gteValue, lte: +lteValue }
    },
  },
]

const filterOptions = {
  checkboxProvidersOptions,
  generalProviderType,
  providersWithGeneral,
  providers,
  compareTabs,
  searchCreatorsSortBy,
  searchCreatorsTopicSortBy,
  videosSortBy,
  videosSortByCreatorTwitch,
  tagListSortBy,
  tagListDateRange,
  genders,
  ages,
  audienceCountries,
  dateRangeSearch,
  uploadDateSearchVideos,
  uploadDateSearchTopics,
  customUploadDateRangeSearchVideos,
  dataRangeChart,
  dataRangeCompare,
  language,
  countries,
  sortByAvgViewsEngagement,
  creatorPerformanceSortBy,
  topicPerformanceSortBy,
  chart,
  comparePage,
  length,
  likes,
  comments,
  cultureTopicsSortBy,
  cultureSubtopicsSortBy,
  chartLogic,
  engagement,
  views,
  numberOfVideos,
  subtopicType,
  creatorTier,
  topicCategory,
  subtopicTopic,
  subtopicCategory,
  subtopic,
  topic,
  formatId,
  title,
  subtopicSearchTerm,
  searchTopicType,
  searchSubtopicType,
  followedCreators,
  trendingCreators,
  creatorType,
  musicGenre,
  musicSubgenre,
  dateRangeButtons,
  performanceDateRange,
  tagTitle,
  uploadTrendingDates,
  durationOptions,
  categories,
  isLive,
  isAdvertisement,
  compareTopicsRelevanceLogic,
  titleAnd,
  titleOr,
  titleNot,
  youtubeAuditComparePage,
  youtubeAuditDataRangeCompare,
}

export default filterOptions
